export default __webpack_public_path__ + "static/media/instagram.47ba1788.png";